module.exports = __webpack_public_path__ + "img/mockup-tel.4afed98b.svg";